import { useEffect, useState } from 'react'
import APIService from 'services/APIService'

const api = APIService()

const EMPTY = { domains: [], groups: [] }

const useDomainGroup = (domains, enabled = true) => {
  const [result, setResult] = useState(EMPTY)

  useEffect(() => {
    const clean = (domains || '').trim()
    if (!enabled || !clean) {
      setResult(EMPTY)
      return undefined
    }
    let live = true
    const timer = setTimeout(() => {
      api.get('/me/domain-group', { params: { domain: clean } })
        .then(res => {
          if (live) {
            setResult({
              domains: res?.data?.data?.domains || [],
              groups: res?.data?.data?.groups || []
            })
          }
        })
        .catch(() => { if (live) setResult(EMPTY) })
    }, 300)
    return () => { live = false; clearTimeout(timer) }
  }, [domains, enabled])

  return result
}

export default useDomainGroup
